/* unplugin-vue-components disabled */import { ElForm as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElButton as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElFormItem as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import { ElInput as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-419c8894"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "marginR10"
};
const _hoisted_2 = {
  class: "marginR10"
};
import UTable from '@ultra/share/components/UTable/index.vue';
import { UseTable } from '@ultra/share/components/UTable/useTable';
import BindRecordModal from './bindRecordModal.vue';
import BindRole from './bindRole.vue';
import UnbindModal from './unbindModal.vue';
import ToggleBindModal from './toggleBindModal.vue';
import PlayerInfoModal from './playerInfoModal.vue';
import { apiGetPlayerList } from '@/api/gsManage';
import { storeToRefs } from 'pinia';
import { useAppStore } from '@/store/modules/app';
import SelectGS from '../modules/selectGS.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    gsId: {
      type: Number,
      default: 0
    }
  },
  setup(__props) {
    const props = __props;
    const {
      gameInfo
    } = storeToRefs(useAppStore());
    const activeCard = ref('bindManage');
    const bindRecordModalRef = ref();
    const bindRoleRef = ref();
    const unbindRef = ref();
    const toggleBindRef = ref();
    const playerInfoRef = ref();
    const payPanes = ref([{
      title: '绑定管理',
      key: 'bindManage'
    }]);
    const handleClick = (type, data) => {
      if (type === 'bindRecord') {
        bindRecordModalRef.value.show({
          data
        });
        return;
      }
      if (type === 'bind') {
        bindRoleRef.value.show();
        return;
      }
      if (type === 'unbind') {
        unbindRef.value.show({
          data
        });
        return;
      }
      if (type === 'toggleBind') {
        toggleBindRef.value.show({
          data
        });
        return;
      }
      if (type === 'playerInfo') {
        playerInfoRef.value.show({
          data
        });
      }
    };
    const columns = [{
      label: '角色ID',
      prop: 'role_id',
      slot: 'role_id',
      align: 'right',
      width: 200
    }, {
      label: '所属GS',
      prop: 'name',
      width: 150
    }, {
      label: '绑定时间',
      prop: 'created_at',
      slot: 'created_at'
    }, {
      label: '操作',
      action: true
    }];
    const filter = ref({
      role_id: '',
      gs_chairman_id: undefined
    });
    const getTableData = async () => {
      tableLoading.value = true;
      const res = await apiGetPlayerList({
        game_id: gameInfo.value.Id,
        gs_chairman_id: filter.value.gs_chairman_id,
        page: current.value,
        page_size: pageSize.value,
        role_id: filter.value.role_id
      });
      tableLoading.value = false;
      if (res.code === 0) {
        tableData.value = res.data.list;
        total.value = res.data.total;
      }
    };
    const {
      tableData,
      tableLoading,
      current,
      pageSize,
      total,
      handleSizeChange,
      handleCurrentChange
    } = UseTable(getTableData);
    watch(() => props.gsId, val => {
      if (val) {
        filter.value.gs_chairman_id = val;
      }
    }, {
      immediate: true
    });
    watch(() => gameInfo.value, val => {
      if (val) getTableData();
    }, {
      immediate: true,
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_el_input = __unplugin_components_0;
      const _component_el_form_item = __unplugin_components_1;
      const _component_el_button = __unplugin_components_2;
      const _component_el_form = __unplugin_components_3;
      const _component_u_card_pane = _resolveComponent("u-card-pane");
      const _component_u_card = _resolveComponent("u-card");
      return _openBlock(), _createBlock(_component_u_card, {
        modelValue: _unref(activeCard),
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _isRef(activeCard) ? activeCard.value = $event : null),
        panes: _unref(payPanes)
      }, {
        "left-extra": _withCtx(() => [_createVNode(_component_el_form, {
          inline: "",
          class: "search-container"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "角色ID"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(filter).role_id,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(filter).role_id = $event),
              placeholder: "输入角色ID"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "所属GS"
          }, {
            default: _withCtx(() => [_createVNode(SelectGS, {
              modelValue: _unref(filter).gs_chairman_id,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(filter).gs_chairman_id = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              onClick: getTableData
            }, {
              default: _withCtx(() => [_createTextVNode("搜索")]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        extra: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[2] || (_cache[2] = $event => handleClick('bind'))
        }, {
          default: _withCtx(() => [_createTextVNode("绑定")]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_u_card_pane, {
          name: "bindManage"
        }, {
          default: _withCtx(() => [_createVNode(UTable, {
            options: columns,
            "row-key": "cid",
            data: _unref(tableData),
            loading: _unref(tableLoading),
            total: _unref(total),
            "current-page": _unref(current),
            "page-size": _unref(pageSize),
            onSizeChange: _unref(handleSizeChange),
            onCurrentChange: _unref(handleCurrentChange),
            pagination: ""
          }, {
            role_id: _withCtx(({
              scope
            }) => [_createElementVNode("span", _hoisted_1, _toDisplayString(scope.row.role_id), 1), _createVNode(_component_el_button, {
              link: "",
              type: "primary",
              onClick: $event => handleClick('playerInfo', scope.row)
            }, {
              default: _withCtx(() => [_createTextVNode("详细信息")]),
              _: 2
            }, 1032, ["onClick"])]),
            created_at: _withCtx(({
              scope
            }) => [_createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$filters.formatDate(scope.row.created_at)), 1), _createVNode(_component_el_button, {
              link: "",
              type: "primary",
              onClick: $event => handleClick('bindRecord', scope.row)
            }, {
              default: _withCtx(() => [_createTextVNode("绑定记录")]),
              _: 2
            }, 1032, ["onClick"])]),
            action: _withCtx(({
              scope
            }) => [_createVNode(_component_el_button, {
              link: "",
              type: "primary",
              onClick: $event => handleClick('toggleBind', scope.row)
            }, {
              default: _withCtx(() => [_createTextVNode("换绑")]),
              _: 2
            }, 1032, ["onClick"]), _createVNode(_component_el_button, {
              link: "",
              type: "danger",
              onClick: $event => handleClick('unbind', scope.row)
            }, {
              default: _withCtx(() => [_createTextVNode("解绑")]),
              _: 2
            }, 1032, ["onClick"])]),
            _: 1
          }, 8, ["data", "loading", "total", "current-page", "page-size", "onSizeChange", "onCurrentChange"])]),
          _: 1
        }), _createVNode(BindRecordModal, {
          ref_key: "bindRecordModalRef",
          ref: bindRecordModalRef
        }, null, 512), _createVNode(BindRole, {
          ref_key: "bindRoleRef",
          ref: bindRoleRef,
          gid: _unref(gameInfo).Id,
          onOk: getTableData
        }, null, 8, ["gid"]), _createVNode(UnbindModal, {
          ref_key: "unbindRef",
          ref: unbindRef,
          onOk: getTableData
        }, null, 512), _createVNode(ToggleBindModal, {
          ref_key: "toggleBindRef",
          ref: toggleBindRef,
          onOk: getTableData
        }, null, 512), _createVNode(PlayerInfoModal, {
          ref_key: "playerInfoRef",
          ref: playerInfoRef
        }, null, 512)]),
        _: 1
      }, 8, ["modelValue", "panes"]);
    };
  }
});